import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button.js';

import { Add, Create, FileCopySharp, Visibility } from '@material-ui/icons';

import { wsFindBy } from 'services/WService.js';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { Tooltip } from '@material-ui/core';
import Badge from 'components/Badge/Badge';

//modal
import Modal from './Modal';
import Modal2 from './ModalUpdate';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';
import { Link } from 'react-router-dom';


const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const useStyles = makeStyles(styles);
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 250 },
  { Header: 'ID', accessor: 'id', width: 50 },
  // { Header: 'Estado', accessor: 'state' },
  { Header: 'Código Proveedor', accessor: 'CardCode' },
  { Header: 'Proveedor', accessor: 'CardName' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Total Sin IGV', accessor: 'DocTotal_wo_igv' },
  { Header: 'Descuento IGV', accessor: 'VatSum'},
  { Header: 'Total IGV', accessor: 'DocTotal' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];
const permission = {
  store: 'PURCH_PURCHASES_STORE',
  update: 'PURCH_PURCHASES_UPDATE',
  show: 'PURCH_PURCHASES_SHOW',
  delete: 'PURCH_PURCHASES_DELETED',
};
export default WithApp(function PurchOrder(props) {
  const classes = useStyles();
  const [purchOrder, setPurchOrder] = useState([]);
  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = purchOrder.findIndex((item) => item.id == id);
    purchOrder[index][field] = value;
    setPurchOrder([...purchOrder]);
  };

  async function listPurchOrder(valueSearch) {
    setDataLoading(true);
    let response = await wsFindBy('purch/purchase-order', valueSearch);
    setDataLoading(false);
    if (response.success) setPurchOrder(response.data);
  }

  async function updatePurchOrder(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('purch/purchase-order', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      listPurchOrder(valueSearch);
      
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listPurchOrder(valueSearch);
  }, [valueSearch]);


  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => listPurchOrder(valueSearch)}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => listPurchOrder(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions[permission.store]}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de orden de compra {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={setValueSearch}
              // dateRange
              // diffRange={15}
              provider
              warehouse="N"
            />
            <ReactTable
              excelName="orden_compra"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={purchOrder.map((item, i) => {
                let state;
                let stateColor = '';
                let hasError = false;
                switch (item.state) {
                  case 'D':
                    stateColor = 'warning';
                    state = 'Borrador';
                    break;
                  case 'V':
                    stateColor = 'primary';
                    state = 'Validado';
                    break;
                  case 'C':
                    stateColor = 'primary';
                    state = 'Confirmado';
                    break;
                  case 'S':
                    stateColor = 'primary';
                    state = 'Enviado';
                    break;
                  case 'R':
                    stateColor = 'info';
                    state = 'Recibido';
                    break;
                  case 'F':
                    stateColor = 'success';
                    state = 'Finalizado';
                    break;
                  case 'A':
                    stateColor = 'danger';
                    state = 'Anulado';
                    break;
                  default:
                    stateColor = 'gray';
                    state = 'Otros';
                    break;
                }
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                          disabled={item.state !== 'D'}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.show]}>
                        <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                          <Link to={`${item.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="purch/purchase-order"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            listPurchOrder(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                      <div>
                        <Badge color={stateColor}>{state}</Badge>
                      </div>
                    </div>
                  ),
                  id: item.id,
                  state: state,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  WhsName: item.WhsName,
                  DocTotal_wo_igv: item.DocTotal_wo_igv,
                  // (
                  //   <AllowedGuard
                  //     permission={ConstantPermissions[permission.update]}
                  //     component={item.DocTotal_wo_igv}
                  //   >
                  //     <TextField
                  //       fullWidth
                  //       type="number"
                  //       name="DocTotal_wo_igv"
                  //       margin="normal"
                  //       value={item.DocTotal_wo_igv || ''}
                  //       onChange={(e) => handleChange(item.id, 'DocTotal_wo_igv', e.target.value)}
                  //       onBlur={(e) => updatePurchOrder(item.id, 'DocTotal_wo_igv', e.target.value)}
                  //     />
                  //   </AllowedGuard>
                  // ),
                  DocTotal: item.DocTotal,
                  // (
                  //   <AllowedGuard
                  //     permission={ConstantPermissions[permission.update]}
                  //     component={item.DocTotal}
                  //   >
                  //     <TextField
                  //       fullWidth
                  //       type="number"
                  //       name="DocTotal"
                  //       margin="normal"
                  //       value={item.DocTotal || ''}
                  //       onChange={(e) => handleChange(item.id, 'DocTotal', e.target.value)}
                  //       onBlur={(e) => updatePurchOrder(item.id, 'DocTotal', e.target.value)}
                  //     />
                  //   </AllowedGuard>
                  // ),
                  VatSum: item.VatSum,
                  // (
                  //   <AllowedGuard
                  //     permission={ConstantPermissions[permission.update]}
                  //     component={item.VatSum}
                  //   >
                  //     <TextField
                  //       fullWidth
                  //       type="number"
                  //       name="VatSum"
                  //       margin="normal"
                  //       value={item.VatSum || ''}
                  //       onChange={(e) => handleChange(item.id, 'VatSum', e.target.value)}
                  //       onBlur={(e) => updatePurchOrder(item.id, 'VatSum', e.target.value)}
                  //     />
                  //   </AllowedGuard>
                  // ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
